import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import { styled, useTheme } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import MenuIcon from '@mui/icons-material/Menu';
// import AccountCircle from '@mui/icons-material/AccountCircle';
import MyTextField from '../../components/MyTextField';
import { Grid } from '@mui/material'; // InputAdornment
// import {ReactComponent as MySearchIcon} from '../../assets/images/search-refraction.svg';
// import {ReactComponent as BellIcon} from '../../assets/images/bell.svg';
import {ReactComponent as SignalIcon} from '../../assets/images/signal.svg';
import {ReactComponent as WithoutSignalIcon} from '../../assets/images/without-signal.svg';
import {ReactComponent as ChevronDown} from '../../assets/images/chevron-down.svg';
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useState } from "react";
// import SearchIcon from '@mui/icons-material/Search';
import BusinessIcon from '@mui/icons-material/Business';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SelectCompanyModal from "../SelectCompanyModal";
import { logout, setAuthError } from "../../store/slices/auth";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { changePasswordRequest } from "../../api/authApi";
import MySnackbar from "../MySnackbar";
import ImageProfileCircle from "../ImageProfileCircle";


const drawerWidth = 240;

interface AppBarMenuInterface {
    onClick: () => void,
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
    backgroundColor: theme.s10palette.S10Blueblue700,
    height: "4rem !important",
    padding: "0"
}));

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const UserMenu = () => {

    const authState = useSelector((state: RootState) => state.auth);
    const {companyselected, userData} = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch<AppDispatch>();
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [openModalChangeCompany, setOpenModalChangeCompany] = useState<boolean>(false);
    const [openModalCloseSession, setOpenModalCloseSession] = useState<boolean>(false);
    const [openModalChangePassword, setOpenModalChangePassword] = useState<boolean>(false);
    const [successMsg, setSuccessMsg] = useState<string>("");
    const [errorMsg, setErrorMsg] = useState<string>("");
    const open = Boolean(anchorEl);
    const handleClick = (event: any) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };


    return (
    <Grid 
        sx={{ display: { xs: 'flex', md: 'flex' } }} 
        style={{borderLeft: "0.03125rem solid #666", padding: "0 1rem"}}
    >
        <Grid 
            container 
            width={"3rem"}
            margin={"0 .5rem 0 .5rem"}
        >
            {companyselected?.RUC && <ImageProfileCircle
                width="3rem"
                height="3rem"
                // ruc={userData?.RUCEmpresa as any}
                ruc={companyselected?.RUC as any}
                userId={companyselected?.Code as any}
                userName={`${userData?.ApellidoPaterno} ${userData?.ApellidoMaterno} ${userData?.Nombres}`}
            />}
        </Grid>
        {/* <AccountCircle style={{fontSize: "2.25rem", margin: "0"}}/> */}
        <Grid 
            sx={{ display: { xs: 'none', md: 'flex' } }}
            container 
            direction={"column"} 
            margin={"0 1rem 0 .5rem"}
        >
            <Grid item>
                <Typography 
                    variant='h6'
                    style={{
                        color: "white",
                        fontFamily: "Roboto",
                        fontSize: ".875rem",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "normal",
                        marginTop: ".3rem"
                    }}
                >
                    {authState.sessionData?.FullName}
                </Typography>
            </Grid>
            <Grid item>
                <Typography 
                    variant='h6'
                    style={{
                        color: "white",
                        fontFamily: "Roboto",
                        fontSize: ".75rem",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "normal",
                    }}
                >
                    {authState.companyselected?.Roles.Name}
                </Typography>
            </Grid>
        </Grid>
        <IconButton

            id="demo-customized-button"
            aria-controls={open ? 'demo-customized-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}


            size="large"
            edge="end"
            aria-label="account of current user"
            onClick={handleClick}
            style={{margin: "0", padding: "0"}}
            color="inherit"
        >
            <ChevronDown style={{fontSize: "1.5rem"}}/>
        </IconButton>
        <Menu
            id="demo-customized-menu"
            MenuListProps={{
                'aria-labelledby': 'demo-customized-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            
        >   
            <Grid container direction="column" style={{padding: "1rem"}}>
                <Grid item >
                    <Typography variant="body2">
                        {authState.sessionData?.UserName}
                    </Typography>
                </Grid>
                <Grid item style={{marginTop: ".5rem",}}>
                    <Typography variant="body1">
                        {authState.companyselected?.Name}
                    </Typography>
                </Grid>
            </Grid>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem 
                onClick={() => {
                    setOpenModalChangeCompany(true);
                    handleClose();
                }} 
                disableRipple
            >
                <BusinessIcon style={{fontSize: "1.25rem", color: theme.s10palette.S10Greygrey600}} />
                <Typography variant="subtitle2" marginLeft=".25rem" style={{color: theme.s10palette.S10Greygrey600}}>
                    Cambio de corporacion
                </Typography>
            </MenuItem>
            <MenuItem 
                onClick={() => {
                    setOpenModalChangePassword(true)
                    handleClose();
                }} 
                disableRipple
            >
                <KeyOutlinedIcon style={{fontSize: "1.25rem", color: theme.s10palette.S10Greygrey600}} />
                <Typography 
                    variant="subtitle2" 
                    marginLeft=".25rem" 
                    style={{color: theme.s10palette.S10Greygrey600}}
                >
                    Cambio de contraseña
                </Typography>
            </MenuItem>
            <MenuItem
                onClick={() => {
                    setOpenModalCloseSession(true);
                    handleClose();
                }} 
                disableRipple
            >
                <LogoutOutlinedIcon style={{fontSize: "1.25rem", color: theme.s10palette.S10Greygrey600}} />
                <Typography variant="subtitle2" marginLeft=".25rem" style={{color: theme.s10palette.S10Greygrey600}}>
                    Salir
                </Typography>
            </MenuItem>
        </Menu>
        {openModalChangeCompany && <SelectCompanyModal 
            open={openModalChangeCompany}
            cancelAction={() => {
                setOpenModalChangeCompany(false);
            }}
            errorMessage={(error) => dispatch(setAuthError(error))}
        />}
        {openModalChangePassword && <PasswordModal
            open={openModalChangePassword}
            onClose={() => setOpenModalChangePassword(false)}
            onSuccess={() => {
                setSuccessMsg("La contraseña fué actualizada.")
            }}
            onError={(error) => setErrorMsg(error)}
        />}
        {openModalChangeCompany && <SelectCompanyModal 
            open={openModalChangeCompany}
            cancelAction={() => {
                setOpenModalChangeCompany(false);
            }}
            errorMessage={(error) => dispatch(setAuthError(error))}
        />}
        {openModalCloseSession && <Dialog
            open={openModalCloseSession || openModalChangePassword}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
            sx={{
              "& .MuiDialog-container": {
                "& .MuiPaper-root": {
                  width: "25rem", 
                  maxWidth: "25rem", 
                },
              },
            }}
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Cerrar sessión
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <Typography variant="subtitle1">
                    ¿Deseas cerrar sesión del S10?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => setOpenModalCloseSession(false)}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained" 
                            style={{minWidth: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={() => dispatch(logout())}
                        >
                            Cerrar sesión
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}
        
        <MySnackbar 
            open={errorMsg !== ""}
            autoHideDuration={6000}
            msg={errorMsg}
            severity="error"
            onClose={() => setErrorMsg("")} 
        />
        <MySnackbar 
            open={successMsg !== ""}
            autoHideDuration={6000}
            msg={successMsg}
            severity="success"
            onClose={() => setSuccessMsg("")} 
        />
    </Grid>
    )
}

interface PasswordModalProps {
    open: boolean, 
    onClose: () => void, 
    onSuccess: () => void,
    onError: (msg: string) => void,
}

const PasswordModal = (
    {open, onClose, onSuccess, onError}: PasswordModalProps 
) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [currentPassword, setCurrentPassword] = useState<string>("");
    const [newPassword, setNewPassword] = useState<string>("");
    const [confirmNewPassword, setConfirmNewPassword] = useState<string>("");

    const handleChangePassword = async () => {
        setLoading(true)
        const result = await changePasswordRequest({
            CurrentPassword: currentPassword, 
            NewPassword: newPassword, 
            ConfirmNewPassword: confirmNewPassword
        });
        setLoading(false)
        if (!result || result.Type !== 0) {
            const msg = !result ? "Ocurrió un error, por favor reintenta nuevamente." : result.Message;
            onError(msg);
        } else {
            onSuccess();
            onClose();
        }
        console.log(result)
    }

    return (
        <Dialog
            open={open}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%", zIndex: 1200}}
            sx={{
              "& .MuiDialog-container": {
                "& .MuiPaper-root": {
                  width: "25rem", 
                  maxWidth: "25rem", 
                },
              },
            }}
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Cambiar la contraseña
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <Grid container direction="column">
                    <Grid item>
                        <MyTextField
                            label="Ingresa contraseña actual"
                            fullWidth
                            type="password"
                            style={{width: "100%"}}
                            onChange={({target}) => setCurrentPassword(target.value)}
                            value={currentPassword}
                        />
                    </Grid>
                    <Grid item marginTop="1.5rem">
                        <MyTextField
                            label="Nueva contraseña"
                            fullWidth
                            type="password"
                            style={{width: "100%"}}
                            onChange={({target}) => setNewPassword(target.value)}
                            value={newPassword}
                        />
                    </Grid>
                    <Grid item marginTop="1.5rem">
                        <MyTextField
                            label="Confirmar nueva contraseña"
                            fullWidth
                            type="password"
                            style={{width: "100%"}}
                            onChange={({target}) => setConfirmNewPassword(target.value)}
                            value={confirmNewPassword}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            disabled={loading}
                            onClick={onClose}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained" 
                            style={{minWidth: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            disabled={loading}
                            onClick={handleChangePassword}
                        >
                            Cambiar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>)
} 

const AppBarMenu = ({onClick}: AppBarMenuInterface) => {

    const authState = useSelector((state: RootState) => state.auth);
    // const theme = useTheme();
    // const [hiddenSearchInput, setHiddenSearchInput] = useState(true)

    return (
    <AppBar position="fixed" elevation={0} color='primary'>
        <Toolbar style={{height: "4rem", padding: "0 1rem"}}>
            <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={onClick}
                edge="start"
                sx={{
                    height: "2rem",
                }}
            >
                <MenuIcon style={{fontSize: "2rem"}} />
            </IconButton>
            <Grid container alignItems="center">
                <Grid 
                    item 
                    xs={11} 
                    md={5}
                    height={"4rem"}
                    width="100%"
                    padding={"0.75rem"}
                    sx={{display: {xs: 'none', md: 'block'}}}
                >
                    {/* <MyTextField 
                        id="search"
                        type='search'
                        style={{borderRadius: ".5rem", padding: "0", margin: "0", width: "100%"}}
                        placeholder="Buscar..."
                        InputProps={{
                        startAdornment: <InputAdornment position="start" style={{color: theme.s10palette.S10Greygrey900, margin: "0.5rem .75rem"}}>
                            <MySearchIcon/>
                        </InputAdornment>
                        }}
                    /> */}
                </Grid>
                {/* {!hiddenSearchInput && <Grid item xs={1}  sx={{display: {xs: 'block', md: 'none'}}}>
                    <IconButton type="button"  aria-label="search" onClick={() => setHiddenSearchInput(true)}>
                        <CloseIcon style={{fontSize: "2rem", color: "white"}}/>
                    </IconButton>
                </Grid>} */}
                <Grid 
                    container 
                    item
                    xs={12}
                    md={7}
                    justifyContent={"end"}
                    alignItems={"center"} 
                
                >
                    <Grid sx={{ display: { xs: 'block', md: 'flex' } }}>

                        {/* <IconButton size="large" aria-label="search" color="inherit" onClick={() => setHiddenSearchInput(false)}>
                            <SearchIcon style={{fontSize: "1.7rem"}} />
                        </IconButton> */}

                        {/* <IconButton size="large" aria-label="show notifications" color="inherit">
                            <Badge badgeContent={4} color="error">
                                <BellIcon style={{fontSize: "1.5rem"}} />
                            </Badge>
                        </IconButton> */}
                        <IconButton
                            size="large"
                            color="success"
                            sx={{
                                '&:hover': {
                                color: "red"
                                },
                            }}
                        >
                            { authState.connectionId 
                                ? <SignalIcon style={{fontSize: "1.5rem"}}  />
                                : <WithoutSignalIcon style={{fontSize: "1.5rem"}}  />
                            }
                        </IconButton>
                    </Grid>

                    <UserMenu />
                </Grid>
            </Grid>
        </Toolbar>
    </AppBar>
    );
};

export default AppBarMenu;